export default {
  shape: `
    <path d="M11.92 5.25l-5.958 5.958L3.254 8.5" stroke="#333" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
  `,
};
